import { render, staticRenderFns } from "./otherStore.vue?vue&type=template&id=e2d56580&scoped=true&"
import script from "./otherStore.vue?vue&type=script&lang=js&"
export * from "./otherStore.vue?vue&type=script&lang=js&"
import style0 from "./otherStore.vue?vue&type=style&index=0&id=e2d56580&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d56580",
  null
  
)

export default component.exports